export const cashOnlyMerchants = [
  "1676366772801599909", // Genting CCT
  "1673428628829099224", // Kenneth Merchant
  "491123266994209539" // Wetix Merchant Production
];
